import { TransactionState, TransactionResponse } from './types'
import { createSlice } from '@reduxjs/toolkit'
import { getTransactions } from './transaction.services';

export const initialState: TransactionState = {
    data: {} as TransactionResponse,
    status: "loading",
    error: {}
}

export const TransactionSlice = createSlice({
    name: 'transactions',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getTransactions.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(getTransactions.fulfilled, (state, action) => {
                if (action.payload) {
                    console.log('EEW', action.payload.data)
                    state.data = action.payload.data;
                    state.status = action.payload.status;
                    state.error = action.payload.error
                }
            })
            .addCase(getTransactions.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error
            })
    }
})

export const TransactionReducer = TransactionSlice.reducer